
export default {
    actions: {
        executeUnauthenticated: (document.location.hostname === 'localhost') ? 'https://localhost:5001/api/UnauthenticatedTerminal/' : 'https://prem-api-dev1.pongstudios.ca/api/UnauthenticatedTerminal/',
    }
};